import React from 'react';
import InfoIcon from './InfoIcon';

const badgeConfig = {
  popular: { text: 'Most Popular!', from: '#6EC9AB', to: '#00A3DA' },
  limited: { text: 'Limited Stock', from: '#C01F85', to: '#009CFF' },
  lowCost: { text: 'Low Cost', from: '#6EC9AB', to: '#00A3DA' },
  // …add more types here if you need
};

export default function TopCard({
  item,
  quantity,
  price,
  showProductsOneRow,
  currencyStore,
  productTitle,
  badgeType = 'popular',
  limitedProductCount,
  limitedProductMaxCount,
  onAdd,
  onRemove,
  onBlur,
  currAmount,
}) {
  const { text, from, to } = badgeConfig[badgeType] || badgeConfig.popular;

  const displayedCount = limitedProductMaxCount ? Math.max(0, limitedProductMaxCount - 4000) : 0;
  const isBlue = displayedCount > 0;


  return (
    <div className="bg-white border border-[#00A3DA] rounded-lg flex flex-col items-center p-1 md:p-2 mb-2" tabIndex={0} onBlur={onBlur}>
      {/* header */}
      <div className="flex w-full justify-between items-center ml-1">
        <h3 className="font-brandingBold text-[#00A3DA] text-left">{item.name}</h3>
        <span
          className="text-white text-xs font-semibold rounded-full px-3 py-1"
          style={{ backgroundImage: `linear-gradient(to right, ${from}, ${to})` }}
        >
          {text}
        </span>
      </div>

      {/* body */}
      <div className="w-full flex flex-col mt-1">
        <div className="flex items-center w-full justify-center">
          <img
            src={item.image_link}
            alt={item.name}
            className={`${showProductsOneRow ? '' : 'hidden-'} md:block w-16 h-16 object-cover mr-2 rounded shadow-md`}
          />

          <div className="w-full flex flex-col">
            <div className="flex items-center w-full justify-between">
              <p
                className="
      flex-1
      font-branding text-[13px] leading-[12px]
      text-left decoration-[1px] text-[#00A3DA]
      whitespace-normal
    "
              >
                {productTitle}
              </p>

              <InfoIcon className="w-5 h-5 flex-shrink-0 ml-2" />
            </div>

            <div className="text-left">
              {limitedProductMaxCount != null && (
                <span className={`whitespace-nowrap ${isBlue ? 'text-[#00A3DA]' : 'text-pink'}`}>Only {displayedCount} Left</span>
              )}
            </div>
            {/* price + qty controls */}
            <div className={`flex items-center justify-between w-full ${limitedProductMaxCount ? '' : 'mt-2 md:mt-4'}`}>
              {/* price */}
              <div className="flex items-center bg-[#E9F7FF] rounded px-2 py-1">
                <span className="font-brandingBold text-[#00A3DA] text-[17px] px-2 py-1 leading-[12px] text-center">
                  {currAmount(currencyStore, price)}
                </span>
              </div>

              {/* “–  qty  +” */}
              <div className="flex items-center bg-[#E9F7FF] p-1 rounded min-w-[107px] justify-between">
                <button
                  className="bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3"
                  onClick={onRemove}
                  disabled={quantity === 0}
                >
                  –
                </button>
                <span className="text-[#00A3DA] text-[17px] px-2">{quantity}</span>
                <button className="bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3" onClick={onAdd}>
                  +
                </button>
              </div>

              {/* Add button */}
              <button className="bg-pink text-white ml-3 px-2 py-1 rounded-lg min-w-[64px]" onClick={onAdd}>
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
